
import {defineComponent, nextTick} from 'vue';

import {isEmpty} from "lodash-es/lodash";
import { BlockContent } from '@/models/Blocks/Itens/block-content';
import { BlockFactory } from "@/models/Blocks/Itens/block-factory";
import { HistoryPosition } from '@/models/Blocks/history-position';

import RelatedList from "@/models/Product/related-list";
import operatingSystem from "@/Utilities/operating-system";
import productPage from "@/api/productPage";
import utilities from "@/Utilities/common";
import {storePdp} from '@/store/product-page';

import MuffinLoader from "@/components/Muffin/Loader.vue";
import CampaignBlocks from '@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/CampaignBlocks.vue';
import ComboBlocks from '@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/CombosBlocks.vue';
import RelatedProductsBlocks from '@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/RelatedProductsBlocks.vue';
import SocialBlocks from '@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/SocialBlocks.vue';
import Single from "@/components/Blocks/Block/Single.vue";

export default defineComponent({
    store: storePdp,
    name: 'ProductDetailsBlocks',
    components: {
        MuffinLoader,
        Single,
        CampaignBlocks,
        RelatedProductsBlocks,
        SocialBlocks,
        ComboBlocks,
        NutTable: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/Content/NutTable.vue'),
        Description: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/Content/Description.vue'),
        InfoAndCare: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/Content/InfoAndCare.vue'),
        ManualsAndDoc: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/Content/ManualsAndDoc.vue'),
        BlockContentPopup: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/BlockContentPopup.vue'),
        PackElementsSelect: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/Content/PackElementsSelect.vue'),
        Reviews: () => import('@/components/ProductPage/Reviews/Reviews.vue'),
        ProductDisplay: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/Content/ProductDisplay.vue'),
        PackBlocks: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/PackBlocks.vue'),
        //Single: () => import('@/components/Blocks/Block/Single.vue'),
        //CampaignBlocks: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/CampaignBlocks.vue'),
        //ComboBlocks: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/CombosBlocks.vue'),
        //RelatedProductsBlocks: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/RelatedProductsBlocks.vue'),
        //SocialBlocks: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/SocialBlocks.vue'),
    },
    props: {
        masterId: String,
        sku: String,
        url: String,
        socialUrl:{
            type: String,
            default: undefined
        },
        blocksData: null,
        renderPackContentBlocks: {
            type: Boolean,
            default: false
        },
    },
    data(){
        let relatedProductsData: Array<any> = [];
        let relatedBlockKey: any = null;
        let typeHistory: string = 'openModalHistory';
        return {
            pagePopupTitle: '',
            relatedProductsData, // related products display modals
            relatedBlockKey,
            preLoadRelatedRow: false,
            preLoadComboRow: false,
            isLoading: false,
            typeHistory
        }
    },
    computed: {
        blocksColor() {
            let blocksColor = this.$store.getters.blocksColor;
            if(!blocksColor) { // just in case
                return '#333';
            }

            return blocksColor;
        },
        kStrings() {
            return this.$store.getters.kStrings;
        },
        showPagePopup() { // '' (hides), pack, stock form, tabs content , etc.. (shows)
            return this.$store.getters['pdpDesktop/addToCartDesktop/showPagePopup'];
        },
        // legacy computed tab data
        commentsTabName() {
            return this.$store.getters.CommentsLabel;
        },
        tabSelected() {
            return this.$store.getters.TabSelected;
        },
        groupId() {
            return this.$store.getters.GroupId;
        },
        selectedKey() {
            return this.tabSelected ? this.tabSelected.key : null;
        },
        descriptionTabUrl() {
            return this.tabUrl;
        },
        tabUrl() {
            return this.tabSelected ? this.tabSelected.url : null;
        },
        showElementsSelect() {
            const i = this.tabSelected ? this.tabSelected.info : null;
            return i && i.hasOwnProperty('showSelect') && i.showSelect;
        },
        packElements() {
            const i = this.tabSelected ? this.tabSelected.info : null;
            return i && i.hasOwnProperty('options') ? i.options : [];
        },
        selElement() {
            return this.$store.getters.PackEleSelected;
        },
        packElementsLabel() {
            const i = this.tabSelected ? this.tabSelected.info : null;
            return i && i.hasOwnProperty('label') ? i.label : '';
        },
        selProdId() {
            return this.selElement ? this.selElement.groupId : this.groupId;
        },
        masterSku() {
            return this.$store.getters.masterSku ? this.$store.getters.masterSku : this.$store.getters.SKU;
        },
        selSku() {
            if(this.renderPackContentBlocks) {
                return this.selElement && this.selElement.sku ? this.selElement.sku : this.$store.getters.SKU;
            }
            let selectedProduct = this.$store.getters['pdpDesktop/addToCartDesktop/selectedProduct'];
            let defaultSku = this.tabsData ? this.tabsData.sku :this.masterSku;
            return !isEmpty(selectedProduct) ? selectedProduct.sku : defaultSku;
        },
        productCartData() {
            return this.$store.getters['pdpDesktop/addToCartData'];
        },
        productInfo() {
            if(!this.productCartData) {
                return null;
            }
            return this.productCartData.productInfo;
        },
        openBlockContent() {
            return this.showPagePopup && (this.showPagePopup !== 'stock') && !this.showPagePopup.includes('related') && !this.showPagePopup.includes('LIST_DISPLAY');
        },
        /*openBlockContentRelated() { // related display
            return this.showPagePopup && this.showPagePopup.includes('related') && !this.showPagePopup.includes('MATCH_WITH');
        },*/
        openBlockContentMatchWith() { // math with display
            return this.showPagePopup && this.showPagePopup.includes('MATCH_WITH');
        },
        minimalModal() {
            return this.showPagePopup && (this.selectedKey == 'COMMENTS' || this.selectedKey == 'DESCRIPTION');
        },
        hasBrowserHistory() {
            return this.showPagePopup && !this.showPagePopup.includes('related-');
        },
        pknFillGapBlocks() {
            if(!this.renderPackContentBlocks) {
                return null
            }

            return productPage.singleBlockFactory(this.blocksData.fillPknGap)
        },

        isIOS(){
            return operatingSystem.isIOS();
        },
        tabsData() {
            return this.$store.getters['pdpDesktop/tabsData'];
        },
        firstRowBlocks() {
            if(isEmpty(this.blocksData) || !this.blocksData.firstRowStruct) {
                return null;
            }

            return productPage.singleBlockFactory(this.blocksData.firstRowStruct);
        },

        secondRowBlocks() {
            if(isEmpty(this.blocksData) || !this.blocksData.secondRowStruct) {
                return null;
            }

            if(this.blocksData.secondRowStruct.length != 3){
                return null;
            }

            let patchedBlocks: Array<any> = [];
            this.blocksData.secondRowStruct.forEach((element: any) => {
                let obj = BlockFactory.get(element);
                if(obj){
                    obj.backgroundColor = this.blocksColor;
                    if(obj instanceof BlockContent){
                        let action = obj.action?.type??'';
                        if(action == 'dynamicBlockImage' &&  this.dynamicBlockImage) {
                            obj.clearImages();
                            obj.addImage(this.dynamicBlockImage.image,null,true);
                        }
                    }
                    patchedBlocks.push(obj);
                }
            });
            return this.blocksData.secondRowStruct.length == 3 ? productPage.singleBlockFactory(patchedBlocks) : null;
        },
        thirdRowBlocks() {
            if (isEmpty(this.blocksData) || !this.blocksData.thirdRowStruct) {
                return null;
            }

            return this.blocksData.thirdRowStruct.length == 3 ? productPage.singleBlockFactory(this.blocksData.thirdRowStruct) : null;
        },
        enableSideDetails() { // combo & cpgs "non black rabbit" section
            return this.$store.getters['pdpDesktop/enableSideDetails'] || this.$store.getters['pdpDesktop/enableReverseSideDetails'];
        },
        dynamicBlockImage() {
			const imgs = this.$store.getters['pdpDesktop/blockImageRecords'];
            return isEmpty(imgs) ? null : imgs.find((elm:any) => elm.sku == this.selSku);
        }
    },
    created() {
        this.$store.dispatch('initInfo', {groupId: this.masterId, sku: this.sku});
        this.$store.dispatch('initTabs', {tabs: this.tabsData, url: this.url});
    },

//    beforeMount() { },
    mounted() {
        this.$nextTick(() => {
            this.initHistoryPopState();
            let urlLocation = new URL(window.location.href);
            const labelNutrition = urlLocation.searchParams.get('label');
            const comment = urlLocation.searchParams.get('comment') || urlLocation.href.includes('modal-comments');
            const description = urlLocation.href.includes('modal-description');
            const infoAndCare = urlLocation.href.includes('modal-info_and_care');
            const manualsDocumentation = urlLocation.href.includes('modal-manuals_documentation');
            if(labelNutrition) {
                this.openModalByKey('NUTRITION_TABLE');
            } else if(comment) {
                this.openModalByKey('COMMENTS');
            } else if(description) {
                this.openModalByKey('DESCRIPTION');
            } else if(infoAndCare) {
                this.openModalByKey('INFO_AND_CARE');
            } else if(manualsDocumentation) {
                this.openModalByKey('MANUALS_DOCUMENTATION');
            }
        });

        if(HistoryPosition.isBack()){
            if ('scrollRestoration' in history) {
                history.scrollRestoration = 'manual';
            }
            this.backLoadBlocks();
        }
    },
    watch: {
        groupId(val) {
            if (val && this.selectedKey == 'DESCRIPTION') {
                this.$emit('scroll-into-view');
            }
        },
    },
    methods: {
        setIsLoading(value: boolean) {
            this.isLoading = value;
        },
        async backLoadBlocks(){

            let related = new RelatedList();
            if(related.getData() && this.groupId == related.getGroupId()) {
                this.preLoadRelatedRow = true;

                //wait DOM update
                await nextTick();

                if(related.getType() == this.typeHistory){
                    this.setRelatedModalStatus(related.getData(), true, false);
                }
            }
        },
        async openModalByBlockValue(blockValue: any) {
            let key   = blockValue?.modalKey??null;

            if(this.relatedBlockKey && key && this.relatedBlockKey == key) {
                return this.scrollRelatedIntoView(false);
            }

            let hash  = window?.location?.hash??null;
            if(hash){
                await history.back();
            }
            if (blockValue) {
                let url = blockValue.url ?? null;
                if (url) {
                    this.setRelatedModalStatus(blockValue, true, true);
                } else {
                    let tabs = this.tabsData.tabsData;
                    const tab = tabs.find((elem : any) => elem.key == blockValue.modalKey);
                    this.onTabSelect(tab);
                }
            }
        },
        openBlockVideo(blockValue: any) {
            if (blockValue) {
                this.playVideo(blockValue.openVideo);
            }
        },
        openRelatedProducts(block: BlockContent|null|undefined) {
            if(block && block.action) {
                this.openModalByBlockValue(block.action.value);
            }
        },
        playVideo(videoDataObj: any) {
            this.$store.commit('pdpDesktop/updateVideoModal', {show: true, videoData: videoDataObj})
        },
        tabName(tab: any) {
            return tab.key == 'COMMENTS' && this.commentsTabName ? this.commentsTabName : tab.name;
        },
        hasNutritionTable() {
            let tabs = this.tabsData.tabsData;
            const nutTableTab = tabs ? tabs.find((elem: any) => elem.key == 'NUTRITION_TABLE') : null;
            return nutTableTab && nutTableTab.url ? true : false;
        },
        onProductChanged(p: any) {
            this.$store.dispatch('packSelected', p);
        },
        openModalByKey(key: string|undefined|null) {
            // needs app evtmodal event no?
            if (key) {
                let tabs = this.tabsData.tabsData;
                const tab = tabs.find((elem: any) => elem.key == key);
                this.onTabSelect(tab);
            }
        },
        onTabSelect(tab: any) {  // todo improve handling of multiple open modals now :(
            this.$store.dispatch('tabSelected', tab);
            if (tab) {
                if(tab.key=='NUTRITION_TABLE'){
                    //tab URL click
                    const url = new URL(window.location.href);
                    url.searchParams.set('label', btoa(this.$store.getters.SKU));
                    // use replace state because pushState rises some problems
                    // in Firefox with back button (empty referrer)
                    const state = {pdpModalOpen: true, key: tab.key};
                    history.pushState(state, "", url);
                } else if (!window.location.toString().includes("#modal-")) {
                    let modalUrl = '#modal-' + tab.key.toLowerCase();
                    const state = {pdpModalOpen: true, key: tab.key};
                    const url = window.location.href + modalUrl;
                    history.pushState(state, "", url);
                }
                this.$emit('scroll-into-view');
            } else { // don't know if this is necessary
                const url = new URL(window.location.href);
                url.searchParams.delete('label');
                url.searchParams.delete('comment');
                url.searchParams.delete('modal-comments');
                url.searchParams.delete('modal-description');
                url.searchParams.delete('modal-info_and_care');
                url.searchParams.delete('modal-modal-manuals_documentation');
                history.replaceState({pdpModalOpen: false, key: ''}, "", " ");
            }

            this.pagePopupTitle = tab && tab.key != 'DESCRIPTION' ? tab.name : '';
            if(this.pagePopupTitle && tab.modalTitle) {
                this.pagePopupTitle = tab.modalTitle;
            }
            this.$store.dispatch('pdpDesktop/addToCartDesktop/updateShowPagePopup', tab ? tab.key : '');
            this.removeModal();
        },
        async setRelatedModalStatus(blockValue: any, status: boolean = true, addHistory: boolean = true) { 
            let url = blockValue.url ?? null;
            if(status && url){
                this.isLoading = true;
                let relatedBlockKey:any = blockValue.modalKey??'-';
                let data = await productPage.getModalContent(url,(blockValue.data??{}),relatedBlockKey);
                this.setShowPagePopup(blockValue?.modalTitle??'',relatedBlockKey,data, blockValue, addHistory);
                this.isLoading = false;
            }else{
                history.back();
            }
        },
        setShowPagePopup(title: string, key: string, list: any[], dataHistory: any, addHistory: boolean = true){
            this.pagePopupTitle = title;
            this.relatedProductsData = list;
            this.relatedBlockKey = key;

            if(addHistory){
                let related = new RelatedList(this.typeHistory);
                related.save(dataHistory,this.groupId);
            }

            this.$nextTick(() => {
                this.scrollRelatedIntoView(false);
            });
        },
        scrollRelatedIntoView(retry: boolean){
            let timeout = 100;
            const pdpRelatedBlocks = document.getElementById('blockContentPopupRelated');
            if(pdpRelatedBlocks) {
                utilities.scrollIntoViewWithOffset(pdpRelatedBlocks, 76, timeout);
            }else if(!retry){
                setTimeout(()=> {
                    this.scrollRelatedIntoView(true);
                },timeout);
            }
        },
        removeModal(){
            this.relatedProductsData = [];
            this.relatedBlockKey = null;
        },
        initHistoryPopState() { // back on open modals
            window.addEventListener('popstate', event => {
                if (!event.state || (event.state && !event.state.pdpModalOpen)) {
                    this.onTabSelect('');
                }
            });
        },
        setRowBlockVisibility(structItem: BlockContent|null = null) { // first row block visibility on open content
            if(structItem) {
                if(structItem.type != 7 || !structItem.action) { // !== type content -> code 7
                    return true;
                }
                return !this.tabSelected || this.tabSelected && this.tabSelected.key !== structItem.action.value.modalKey;
            }

            return !this.tabSelected;
        },
        itemClickHandler(item: any, targetElm: HTMLElement| undefined = undefined) {
            if(!item) {
                return
            }

            if(targetElm) {
                this.setIsLoading(true);
            }
        }
    }
});
